import { ApolloProvider } from '@apollo/react-hooks';
import ApolloClient from 'apollo-boost';
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useContext } from 'react';
import { dataTableResolvers } from '@bit/glinzcovis.shamekit.table-of-shame';
import { AppContext } from '@bit/glinzcovis.shamekit.app-context';
import { useAuth0 } from './auth0-wrapper';

const ApolloSetup = ({ children }) => {
  const { config } = useContext(AppContext);
  const { getTokenSilently } = useAuth0();
  const [currentClient, setCurrentClient] = useState(null);

  const createClient = async () => {
    const token = await getTokenSilently();
    const { gqlEndpoint } = config;
    const client = new ApolloClient({
      uri: gqlEndpoint,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      request: operation => {
        operation.setContext({
          fetchOptions: {
            credentials: 'include',
          },
        });
      },
      cache: new InMemoryCache({
        dataIdFromObject: object => {
          switch (object.__typename) {
            case 'users':
              return `${object.__typename}:${object.user_id}`;
            default:
              return defaultDataIdFromObject(object);
          }
        },
      }),
      resolvers: {
        Mutation: {
          ...dataTableResolvers.mutation,
        },
        Query: {
          ...dataTableResolvers.query,
        },
      },
    });
    setCurrentClient(client);
  };

  useEffect(() => {
    createClient();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (!currentClient) return null;
  return <ApolloProvider client={currentClient}>{children}</ApolloProvider>;
};

ApolloSetup.propTypes = {
  children: PropTypes.object,
};

export default ApolloSetup;
